<template>
  <div>
    <!-- <v-container fluid grid-list-xl class="pa-0 tab-2nd hidden-lg-only">
      <v-tabs touchless v-model="tabs" fixed-tabs color="white" class="w-100 pa-0 white card-r pa-1">
        <v-tab href="#booked" class="tabs" >
          <span class="f-12 text-capitalize">Classes</span>
        </v-tab>
        <v-tab href="#unbooked" class="tabs pt-0">
          <span class="f-12 text-capitalize">Upcoming</span>
        </v-tab>
        <v-tab href="#past" class="tabs pt-0">
          <span class="f-12 text-capitalize">past</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items touchless v-model="tabs" class="tabs" >
        <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="booked" key="1" class="">
          <v-container fluid grid-list-md class="pa-0 mt-3">
            <v-layout row wrap class="">
              <v-flex xs12 class="">
                <v-card class="pa-2 card-r grey lighten-4">
                  <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
                    <div class="text-xs-left f-20 text-capitalize">classes</div>
                  </v-toolbar>
                  <v-list tow-line class="pa-0 transparent">
                    <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                      <div v-if="studentFullClassDetails[ind].class_details.non_booked_modules.length!=0"
                           class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                      <template v-for="(item, index) in studentFullClassDetails[ind].class_details.non_booked_modules">
                        <v-subheader class="justify-center"
                                     v-if="item.header"
                                     :key="item.header"
                        >
                          {{ item.header1 }}
                        </v-subheader>

                        <v-divider
                          v-else-if="item.divider"
                          :inset="item.inset"
                          :key="index"
                        ></v-divider>

                        <v-list-tile class="shadow-1 card-r white mt-2 pa-1"
                                     v-else
                                     :key="item.title"
                                     avatar
                        >
                          <v-list-tile-avatar>
                            <v-avatar color="blue-grey lighten-4">
                              <img v-bind:src="item.image" class="objec-fit">
                            </v-avatar>
                          </v-list-tile-avatar>

                          <v-list-tile-content left class=" pa-0 f-12">
                            <v-list-tile-title class=" pa-0 f-13 font-weight-bold" v-html="item.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="pa-0 f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-action class="right text-xs-right">
                            <v-btn @click="save(item.id,item.package_id),dialog1=true" round
                                   slot="activator" flat class="f-12 tow-clor-1 text-white shadow-1 mt-1 right text-capitalize" small>Book Now</v-btn>
                          </v-list-action>
                        </v-list-tile>
                      </template>
                    </v-flex>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="unbooked" key="2" class="">
          <v-container fluid grid-list-xl class="pa-0 mt-3">
            <v-layout row wrap class="">
              <v-flex xs12 class="">
                <v-card class="pa-2 card-r grey lighten-4">
                  <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
                    <div class="text-xs-left f-20 text-capitalize">Upcoming </div>
                  </v-toolbar>
                  <v-list three-line class="pa-0 transparent">
                    <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                      <div v-if="studentFullClassDetails[ind].class_details.booked_modules.length!=0"
                           class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                      <template v-for="(item, index) in studentFullClassDetails[0].class_details.booked_modules">
                        <v-subheader class="justify-center" v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
                        <v-list-tile class="shadow-1 card-r white mt-2" v-else :key="item.title" avatar>
                          <v-list-tile-avatar>
                            <v-avatar color="green">
                              <img v-bind:src="item.image">
                            </v-avatar>
                          </v-list-tile-avatar>
                          <v-list-tile-content class="">
                            <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                            <v-list-tile-sub-title class="f-12"><span v-html="item.booked_date"></span>
                              <span class="font-weight-bold text-danger" v-html=" 'At ' + item.booked_time"></span> </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-action>
                            <v-btn disabled @click="ChangeTimePopup(item.id,item.package_id,item)" slot="activator" round
                                   class="text-capitalize f-12 ma-0 mb-1 text-primary shadow-1" flat small>change time</v-btn>

                            <v-btn disabled slot="activator" @click="cancelBookPopup(item)" round  class="text-capitalize f-12 ma-0 mb-1 text-primary shadow-1" flat small>Cancel Class</v-btn>

                          </v-list-action>
                        </v-list-tile>
                      </template>
                    </v-flex>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="past" key="3" class="">
          <v-container fluid grid-list-xl class="pa-0 mt-3">
            <v-layout row wrap class="">
              <v-flex xs12 class="">
                <v-card class="pa-2 card-r grey lighten-4">
                  <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
                    <div class="text-xs-left f-20 text-capitalize">Past</div>
                  </v-toolbar>
                  <v-list tow-line class="pa-0 transparent">
                    <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                      <div v-if="studentFullClassDetails[ind].class_details.past_modules.length!=0 || studentFullClassDetails[ind].class_details.completed_modules.length!=0"
                           class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                      <template v-for="(item, index) in studentFullClassDetails[ind].class_details.completed_modules.concat(studentFullClassDetails[ind].class_details.past_modules)">
                        <v-subheader class="justify-center"
                                     v-if="item.header"
                                     :key="item.header"
                        >
                          {{ item.header }}
                        </v-subheader>

                        <v-divider
                          v-else-if="item.divider"
                          :inset="item.inset"
                          :key="index"
                        ></v-divider>

                        <v-list-tile class="shadow-1 card-r white mt-2"
                                     v-else
                                     :key="item.title"
                                     avatar
                                     @click=""
                        >
                          <v-list-tile-avatar>
                            <img v-bind:src="item.image">

                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-action>
                            <v-btn class="text-capitalize card-r tow-clor-1 ma-0 text-white" v-bind:to="'/viewclass/'+item.id"
                                   small round>view</v-btn>
                          </v-list-action>

                        </v-list-tile>
                      </template>
                    </v-flex>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-container> -->
    <v-container fluid grid-list-md class="pa-0 hidden-xs-only hidden-sm-only hidden-md-only">
      <v-layout row wrap class="">
        <v-flex lg4 sm6 xs12 class="">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">classes</div>
            </v-toolbar>
            <!-- <pre class="text-xs-left">{{non_booked_modules}}</pre> -->
            <v-list tow-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
              <v-flex v-for="(studentCls, ind) in studentFullClassDetails" :key="ind">
                <div v-if="studentFullClassDetails[ind].class_details.non_booked_modules.length!=0"
                     class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[ind].class_details.non_booked_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header1 }}
                  </v-subheader>
                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>
                  <v-list-tile class="shadow-1 card-r white mt-2 pa-1"
                               v-else
                               :key="item.title"
                               avatar>
                    <v-list-tile-avatar>
                      <v-avatar color="blue-grey lighten-4">
                        <img v-bind:src="item.module_logo" @click="viewclsvl(item)" class="objec-fit">
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content left class=" pa-0 f-12">
                      <v-list-tile-title class=" pa-0 f-13 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="pa-0 f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-action class="right text-xs-right">
                      <v-btn @click="bookingss(item)" round
                             flat class="f-12 tow-clor-1 text-white shadow-1 mt-1 right text-capitalize" small>Book Now</v-btn>
                    </v-list-action>
                  </v-list-tile>
                </template>
              </v-flex>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex lg4 sm6 xs12 class="pa-1">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">Upcoming</div>
            </v-toolbar>
            <v-list three-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
              <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                <div v-if="studentFullClassDetails[ind].class_details.booked_modules.length!=0"
                     class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[0].class_details.booked_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>

                  <v-list-tile class="shadow-1 card-r white mt-2"
                               v-else
                               :key="item.title"
                               avatar

                  >
                    <v-list-tile-avatar>
                      <v-avatar @click="viewcls = true" color="green">
                        <img v-bind:src="item.module_logo">
                      </v-avatar>
                    </v-list-tile-avatar>

                    <v-list-tile-content class="">
                      <div @click="viewcls = true">
                      <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                      <v-list-tile-sub-title class="f-12"><span v-html="item.booked_date"></span>
                        <span class="font-weight-bold text-danger" v-html=" 'At ' + item.booked_time"></span> </v-list-tile-sub-title>
                      </div>
                    </v-list-tile-content>
                    <v-list-action class="right text-xs-right">
                      <v-btn @click="change_time = true,studentBookingId=item.booked_id" round
                             class="text-capitalize f-12 ma-0 mb-1 text-primary shadow-1" flat small>change time</v-btn>
                      <v-btn @click="cancelClassPopup(item)" round flat class="ma-0 grey--text mt-1 f-12
                       shadow-1 text-capitalize" small>Cancel Class</v-btn>
                      <!--<v-btn flat class="grey text-white card-r no-shadow" small>cancel book</v-btn>-->
                      <!--<v-btn class="primary card-r no-shadow" small>change time</v-btn>-->
                    </v-list-action>
                  </v-list-tile>
                  <!--<v-divider></v-divider>-->
                </template>
              </v-flex>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex lg4 sm6 xs12 class="pa-1">
          <v-card class="pa-2 card-r grey lighten-4" style="height: 75.5vh!important; overflow-y: scroll">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">Past</div>
            </v-toolbar>
            <v-list tow-line class="pa-0 transparent">
              <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                <div v-if="studentFullClassDetails[ind].class_details.teacher_signed_modules.length!=0 || studentFullClassDetails[ind].class_details.completed_modules.length!=0"
                     class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[ind].class_details.teacher_signed_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>

                  <v-list-tile class="shadow-1 card-r white mt-2"
                               v-else
                               :key="item.title"
                               avatar
                               @click=""
                  >
                    <v-list-tile-avatar>
                      <img v-bind:src="item.module_logo">

                      <!--<v-avatar color="blue-grey">-->
                      <!--<v-icon dark>account_circle</v-icon>-->
                      <!--</v-avatar>-->
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <!--<v-btn-->
                    <!--class="primary no-shadow card-r" small color="blue">Book Now</v-btn>&ndash;&gt;-->
                    <v-list-action>
                      <v-btn class="text-capitalize tow-clor-1 ma-0 text-white"
                             round v-bind:to="'/viewclass/'+item.id" small>view</v-btn>
                    </v-list-action>

                  </v-list-tile>
                </template>
              </v-flex>
            </v-list>
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">Completed</div>
            </v-toolbar>
            <v-list tow-line class="pa-0 transparent">
              <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
                <div v-if="studentFullClassDetails[ind].class_details.completed_modules.length!=0"
                     class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[ind].class_details.completed_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>

                  <v-list-tile class="shadow-1 card-r white mt-2"
                               v-else
                               :key="item.title"
                               avatar
                               @click="viewcls = true">
                    <v-list-tile-avatar>
                      <img v-bind:src="item.module_logo">

                      <!--<v-avatar color="blue-grey">-->
                      <!-- <v-icon dark>account_circle</v-icon> -->
                      <!--</v-avatar>-->
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <!--<v-btn-->
                    <!-- <class="primary no-shadow card-r" small color="blue">Book Now</v-btn> -->
                    <v-list-action>
                      <v-btn class="text-capitalize tow-clor-1 ma-0 text-white"
                             round v-bind:to="'/viewclass/'+item.id" small>view</v-btn>
                    </v-list-action>

                  </v-list-tile>
                </template>
              </v-flex>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog class="pa-0" v-model="books" width="600">
      <v-card class="pa-2 card-r grey lighten-4">
        <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
          <div class="text-xs-left f-17 text-capitalize">Book Classs</div>
          <v-spacer></v-spacer>
          <v-btn class="mr-2 tow-clor-1" icon @click="books = false">
            <v-icon class="text-white f-28">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout wrap row xs12 justify-center>
          <v-flex xs12 class="ma-2">
             <!-- <pre class="text-xs-left">{{cls_detail}}</pre> -->
            <practicalbook v-on:viewMoreTime="viewMoreTime" v-on:BookClassPopup="BookClassPopup" v-show="!calendarPopup" v-else="calendarPopup" v-if="books && cls_detail.type!='teori'" :cls_detail="cls_detail"/>
            <theorybook v-on:viewMoreTime="viewMoreTime" v-show="!calendarPopup" v-else="calendarPopup" v-if="books && cls_detail.type=='teori'" :cls_detail="cls_detail"/>
            <calender-book :selectedBookTime="selectedTime" :CalendarBookingType="CalendarBookingType" :cls_times="calenderTimes" :cls_detail="cls_detail" v-if="calendarPopup"/>
            <!-- <complete/> -->
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog class="pa-0 border-r card-r w-100 z-10" v-model="change_time" width="600">
      <v-card class="card-r grey lighten-4 no-shadow">
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 class="ma-2">
                <!--<v-btn small icon @click="change_time = false" class="right grey&#45;&#45;text f-15"><v-icon>close</v-icon></v-btn>-->
                <div class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l">Change Time</div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-container fluid grid-list-md >
              <v-card class=" no-shadow white card-r font-weight-bold text-primary f-15 text-xs-left pa-2">
                <div>1.To change class time, You must to cancel this class & you can change your time!</div>
                <div>2.You get Your Old Payment in your account after canceled class</div>
                <div>3.Booking for that class need a new payment</div>
              </v-card>
            </v-container>
          </v-flex>
          <!-- <v-flex xs6 class="pl-3 pr-1 pb-3"><v-btn class="w-100 ma-0 card-r primary text-capitalize text-white" @click="cancelClass" to="/CalenderBook/120/141/77">Yes i know</v-btn></v-flex> -->
          <!-- <v-flex xs6 class="pl-3 pr-1 pb-3"><v-btn class="w-100 ma-0 card-r primary text-capitalize text-white" @click="cancelBooking(studentBookingId)">Yes i know</v-btn></v-flex> -->
          <v-flex xs12 class="pr-3 pl-1 pb-3"><v-btn class="w-100 ma-0 card-r grey text-white text-capitalize" @click="change_time = false">OK</v-btn></v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog class="pa-0 border-r card-r w-100 z-10" v-model="cancel_class" width="600">
      <v-card class="card-r grey lighten-4 no-shadow">
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 class="ma-2">
                <!--<v-btn small icon @click="cancel_class = false" class="right grey&#45;&#45;text f-15"><v-icon>close</v-icon></v-btn>-->
                <div class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l">Are you sure want to cancel this class?</div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-container fluid grid-list-md >

              <!-- <v-card v-for="(i,ind) in studentFullClassDetails[0].class_details.booked_modules" class=" no-shadow nope card-r text-xs-left pa-2"> -->
              <v-card class=" no-shadow nope card-r text-xs-left pa-2">

                <v-layout xs12 row wrap class="py-2">
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">Class Name: </span>
                    <span class="f-15 font-weight-bold text-primary">{{cancelClassPopupData.name}}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">Date: </span>
                    <span class="f-15 font-weight-bold text-primary">{{cancelClassPopupData.booked_date}}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">time: </span>
                    <span class="f-15 font-weight-bold text-primary">{{cancelClassPopupData.booked_time}}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">Location: </span>
                    <span class="f-15 font-weight-bold text-primary">{{cancelClassPopupData.location}}</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-1 pb-3">
            <v-btn :loading="loadingCancelClass" @click="cancelBook(cancelClassPopupData)" class="w-100 ma-0 card-r primary text-capitalize text-white">Yes</v-btn>
          </v-flex>
          <v-flex xs6 class="pr-3 pl-1 pb-3">
            <v-btn :disabled="loadingCancelClass" @click="cancel_class = false" class="w-100 ma-0 card-r grey text-white text-capitalize">No</v-btn>
          </v-flex>
          <v-flex xs12 class="pr-3 pl-1 pb-3" v-if="cancelClsAlertMsg">
            <v-alert
              :value="true"
              v-if="cancelClsAlertMsg"
              :type="cancelClsAlertType"
            >
              {{cancelClsAlertMsg}}
            </v-alert>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- <v-dialog class="pa-0 border-r card-r w-100" v-model="viewcls" width="500">
      <v-card class="card-r grey lighten-4 no-shadow">
        <v-layout row xs12 justify-center>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 class="ma-2">
                <v-btn small icon @click="viewcls = false" class="right grey--text f-15"><v-icon>close</v-icon></v-btn>
                <div class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l">Practical Class 1 details</div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-container fluid grid-list-md >
              <v-card class=" no-shadow nope card-r text-xs-left pa-2"> -->

                <!-- <v-layout xs12 row wrap class="py-2">
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">Duration :</span>
                    <span class="f-15 font-weight-bold text-primary">135 Minutes</span>
                  </v-flex> -->
                  <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                  <!--<span class="f-15 font-weight-bold text-grey-dark">Date: </span>-->
                  <!--<span class="f-15 font-weight-bold text-primary">2020-01-14</span>-->
                  <!--</v-flex>-->
                  <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                  <!--<span class="f-15 font-weight-bold text-grey-dark">time: </span>-->
                  <!--<span class="f-15 font-weight-bold text-primary">06:00:00</span>-->
                  <!--</v-flex>-->
                  <!-- <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark">Location: </span>
                    <span class="f-15 font-weight-bold text-primary">K�reskolen</span>
                  </v-flex>
                  <v-flex xs12 class="text-xs-left py-0 ">
                    <span class="f-17 font-weight-bold text-grey-dark">Description:</span>
                    <span class="f-15 text-primary font-weight-bold pb-2">dette er en drivende klasse studerende</span>
                    <!--<p class="descriptionList" v-for="tag in ClassData.tags">{{tag.key}} - {{tag.description}}</p>-->
                    <!-- <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                      10 - FORBEREDELSE TIL K�REPR�VE</p>
                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                      10.1 - Betingelser for at f� k�rekort</p>
                    <!-- <span v-show="read"> -->
                                          <!-- <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL K�REPR�VE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at f� k�rekort</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL K�REPR�VE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at f� k�rekort</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL K�REPR�VE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at f� k�rekort</p>
                                    </span>  -->
                    <!-- <v-btn v-show="!read" @click="read = true" class="w-100 card-r ma-0 text-capitalize no-shadow" small>readmore</v-btn>
                    <v-btn v-show="read" @click="read = false" class="w-100 card-r ma-0 text-capitalize no-shadow" small>less</v-btn> -->

                  <!-- </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>  -->
  </div>
</template>
<script>
  /* eslint-disable */
  import { mapState } from "vuex";
  import CalenderBook from './new/CalenderBook'
  import practicalbook from './new/practicalbook'
  import theorybook from './new/theorybook'
  import Complete from './new/Complete'
  import api from "@/utils/backend-api"
  export default {
    props:['id'],
    data () {
      return {
        tabs: "booked",
        cls_detail: '',
        collectedDate:[],
        enableTimeCount:0,
        loading:false,
        seen: false,
        change_time: false,
        cancel_class: false,
        viewcls: false,
        read: false,
        menu1:false,
        menu2:false,
        menu3:false,
        menu4:false,
        startDate:'',
        endDate:'',
        selectedDate:'',
        selectedTime:'',
        dialog1:false,
        books:false,
        dialog2:false,
        dialog3:false,
        allowedDates:{
          date_from:'',
          date_to:'',
        },
        dark:false,
        arrayEvents:[],
        date_from:'',
        date_to:'',
        timeslot:[],
        teacherTime:'',
        studentId: '',
        packageId:'',
        studentClasses: [],
        UpcomingClass: [],
        pastClasses: [],
        msg:false,
        msgText:'',
        alertType:'',
        selectedModuleId:'',
        selectedPackageId:'',
        dialog2Data:'',
        dialog3Data:'',
        AlertMsg:'',
        calendarPopup:false,
        calenderTimes:'',
        // selectedTime:'',
        studentBookingId:'',
        // cancel_class:false,
        cancelClassPopupData:'',
        CalendarBookingType:'',
        cancelClsAlertMsg:'',
        cancelClsAlertType:'',
        loadingCancelClass:false
      }
    },
    watch:{
      id:function(){
        this.getStudentDetails()
      },
      books:function(){
        if(this.books==false){
          this.calendarPopup=false
        }
      }
    },
    beforeCreate(){
      // this.studentId = this.$route.params.id;
      // Store.dispatch('getStudentClass', {'studentid':this.studentId, 'packageid':this.packageId});
    },
    updated:function(){
        let id=this.$route.params.id
        if(id!=this.studentId){
          this.studentId=id
          this.getStudentDetails()
        }
    },
    created() {
      // let a=this.id
      this.getStudentDetails()
//            this.UpcomingClass = Store.dispatch('getStudentUpcomingClass', this.studentId);
//            this.pastClasses = Store.dispatch('getStudentPastClass', this.studentId);
    },
    methods:{
      BookClassPopup(data){
        console.log(data)
        this.selectedTime=data.selected
        this.calenderTimes=data.times
        this.calendarPopup=true
      },
      viewMoreTime(data){
        this.calenderTimes=data.times
        // this.CalendarBookingType=data.bookType
        this.calendarPopup=true
      },
      bookingss(value){
        this.CalendarBookingType=value.type=='teori'?'theory':'practical'
        this.books = true
        this.cls_detail=value
      },
      viewclsvl(value){
        this.books = true
        this.cls_detail=value
      },
       cancelClassPopup(classData){
        this.cancel_class=true
        this.cancelClassPopupData=classData
      },
      cancelPopup(classData){
        this.dialog=true
        this.cancelClassData=classData
      },
      getStudentDetails(){

        let self=this
        this.studentId = this.$route.params.id;
        Store.dispatch('getSingleStudentDetails', this.studentId);
        setTimeout(() => {
          var studentDetails = Store.state.studentDetails;
          var packageId=studentDetails.packages[0].id;
          self.packageId=studentDetails.packages[0].id;
          Store.dispatch('getStudentFullClasses', {'studentid':self.studentId, 'packageid':packageId});
          setTimeout(() => {
            var classDetails = Store.state.studentFullClassDetails;
            self.studentClasses = classDetails.non_booked_modules;
            self.UpcomingClass = classDetails.booked_modules;
            let completedClasses = classDetails.completed_modules;
            let pastClasses = classDetails.pastClasses?classDetails.pastClasses:[];
            self.pastClasses =completedClasses.concat(pastClasses)
          }, 3500);
        },3500);
      },
      bookClass(selectedDate,teacherBookingId,packageId,moduleId){
        this.loading=true
        var data={
          student_id:parseInt(this.$route.params.id),
          module_id:moduleId,
          // module_id:22,
          // package_id:5,
          // teacher_bookings_id:21,
          package_id:packageId,
          teacher_bookings_id:teacherBookingId,
          // date:selectedDate,
          // time:selectedTime
        }
        Store.dispatch("Students/adminBookStudentClass",{data})
          .then(res=>{
            if(res.status==201){
              this.loading=false
              this.msg=true
              this.msgText="Booking Successfully"
              this.alertType="success"
              setTimeout(() => {
                this.dialog1=false
                this.loading=false
                this.msg=false
              }, 2000);
              var studentDetails = Store.state.studentDetails;
              var packageId=studentDetails.packages[0].id
              Store.dispatch('getStudentClass', {'studentid':this.studentId, 'packageid':packageId});
              // Store.dispatch('getStudentFullClasses', {'studentid':this.studentId, 'packageid':packageId});

              setTimeout(() => {
                var classDetails = Store.state.studentClassDetails;
                this.studentClasses = classDetails.non_booked_modules;
                this.UpcomingClass = classDetails.booked_modules;
                this.pastClasses = classDetails.teacher_signed_modules;
              }, 2500);
            }
          }).catch(err=>{
          this.loading=false
          this.msg=true
          this.alertType="warning"
          this.msgText="Booking Failed"
        })
      },
      updateClass(selectedDate,teacherBookingId,studentBookingId,packageId,moduleId){
        this.loading=true
        var data={
          student_id:parseInt(this.$route.params.id),
          module_id:moduleId,
          package_id:packageId,
          teacher_bookings_id:teacherBookingId,
          student_bookings_id:studentBookingId
        }
        Store.dispatch("Students/adminUpdateStudentBookedClass",{data})
          .then(res=>{
            if(res.status==201){
              this.loading=false
              this.msg=true
              this.msgText="Booking Successfully"
              this.alertType="success"
              setTimeout(() => {
                this.dialog2=false
                this.loading=false
                this.msg=false
              }, 2500);
            }
          })
      },
      save(moduleId,packageId){
        this.selectedModuleId=moduleId
        this.selectedPackageId=packageId
        this.msg=false
        this.msgText=""
        this.alertType=""
        this.loading=true
        this.arrayEvents=[]
        let student_id=this.$route.params.id
        let module_id=moduleId
        let package_id=packageId
        // student_id=9
        // module_id=22
        // package_id=5
        this.timeslot=[]
        let data={
          'student_id':parseInt(student_id),
          'module_id':module_id,
          'package_id':package_id
        }
        Store.dispatch("Students/getTeacherTime",data)
          .then(res=>{
            if(res.status==204){
              this.loading=false
              this.msgText="No time for booking this module"
              this.alertType="warning"
              this.msg=true
            }else if(res.status==203){
              this.loading=false
              this.msgText="Not buy this package."
              this.alertType="warning"
              this.msg=true
            }else if(res.status==200){
              setTimeout(() => {
                var teacherTime=Store.state.Students.teacherTime
                this.teacherTime=teacherTime
                this.allowedDates.date_from=teacherTime.date_from
                this.allowedDates.date_to=teacherTime.date_to
                this.selectedDate=this.allowedDates.date_from
                this.date_from=this.allowedDates.date_from
                this.date_to=this.allowedDates.date_to
                this.loading=false
                this.alertType=""
                this.msgText=""
                this.msg=false
                this.arrayEvents=[]
                const response=res.data
                for(var x=0;x<response.times.length;x++){
                  for(var y=0;y<response.times[x].length;y++){
                    var date=response.times[x][y].date
                    this.arrayEvents.push(date)
                  }
                }
              }, 500);
            }else{
              if(res.response.data.error.message){
                this.msgText=res.response.data.error.message
              }else{
                this.msgText="No time for booking this module"
              }
              this.loading=false
              this.alertType="warning"
              this.msg=true
            }
          })
      },
      cancelBookPopup(item){
        this.dialog3Data=item
        this.dialog3=true
      },

      cancelBook(classData,for_what){
        let self=this
        this.Alert={type:'',msg:''}
        this.loadingCancelClass=true
        this.loadingChangeTime=true
        this.cancelClsAlertMsg=''
        this.cancelClsAlertType=''
        api.postData('admin/student_class/student_cancel',{student_bookings_id:classData.booked_id})
        .then(res=>{
          if(res.status==201){
            self.loading=false
            self.loadingCancelClass=false
            self.loadingChangeTime=false
            self.Alert={type:'success',msg:'Successfully cancelled'}
            this.cancelClsAlertMsg='Successfully cancelled'
            this.cancelClsAlertType='success'
            // self.cancel_class=false
            if(for_what=='change_time'){
              self.$router.push('/CalenderBook/'+classData.id+'/'+classData.teacher_data.id+'/'+classData.package_id)
            }else{
              Store.dispatch('getStudentFullClasses', {'studentid':self.studentId, 'packageid':self.packageId});

            }
            // this.alertType="success"
            // this.msg="Successfully cancelled the class"
            // api.postData('student/view_classes')
            // .then(response=>{
            //   // console.log(response)
            //   this.$store.dispatch('setClasses',response.data)
            // })
            // setTimeout(()=>{
            //   this.dialog=false
            //   this.alertType=""
            //   this.msg=""
            // },1500)
            }
        }).catch(err=>{
          self.loadingCancelClass=false
          self.loadingChangeTime=false
          this.cancelClsAlertMsg='Cancellation failed'
          this.cancelClsAlertType='error'
          self.Alert={type:'error',msg:'Cancellation failed'}

          // this.loading=false
          // this.alertType="warning"
          // this.msg="You can not cancel this class"

        })
          // to="/CalenderBook/120/141/77"
      },
      ChangeTimePopup(moduleId,packageId,item){
        this.dialog2Data=item
        this.msg=false
        this.msgText=""
        this.alertType=""
        this.loading=true
        this.arrayEvents=[]
        let student_id=this.$route.params.id
        let module_id=moduleId
        let package_id=packageId
        // student_id=9
        // module_id=22
        // package_id=5
        this.timeslot=[]
        let data={
          'student_id':parseInt(student_id),
          'module_id':module_id,
          'package_id':package_id
        }
        Store.dispatch("Students/getTeacherTime",data)
          .then(res=>{
            if(res.status==204){
              this.loading=false
              this.msgText="No another time for change your module time"
              this.alertType="warning"
              this.msg=true
            }else if(res.status==203){
              this.loading=false
              this.msgText="Not buy this package."
              this.alertType="warning"
              this.msg=true
            }else if(res.status==200){
              setTimeout(() => {
                var teacherTime=Store.state.Students.teacherTime
                this.teacherTime=teacherTime
                this.allowedDates.date_from=teacherTime.date_from
                this.allowedDates.date_to=teacherTime.date_to
                this.selectedDate=this.allowedDates.date_from
                this.date_from=this.allowedDates.date_from
                this.date_to=this.allowedDates.date_to
                this.loading=false
                this.alertType=""
                this.msgText=""
                this.msg=false
                this.arrayEvents=[]
                const response=res.data
                for(var x=0;x<response.times.length;x++){
                  for(var y=0;y<response.times[x].length;y++){
                    var date=response.times[x][y].date
                    this.arrayEvents.push(date)
                  }
                }
              }, 2500);
          }else{
                  this.loading=false
                  this.msgText="No another time for change your module time"
                  this.alertType="warning"
                  this.msg=true
          }
        }).catch((error)=>{
            alert(error)
            if(error.response.status==203){
              self.AlertMsg=err.response.error.message
            }
        })
        this.dialog2=true
      },
      cancelBooking(studentBookingId){
        var Data={
          "student_bookings_id":studentBookingId
        }
        Store.dispatch("Students/cancelBookedClass",Data)
          .then(res=>{
            if(res.status==201){
              this.loading=false
              this.msgText="You are successfully cancelled the booking"
              this.alertType="success"
              this.msg=true
              setTimeout(() => {
                this.dialog3=false
                this.loading=false
                this.msgText=""
                this.alertType=""
                this.msg=false
              }, 1500)
            }else{
              this.loading=false
              this.msgText="You can't cancel the booking"
              this.alertType="warning"
              this.msg=true
              setTimeout(() => {
                this.dialog3=false
                this.loading=false
                this.msgText=""
                this.alertType=""
                this.msg=false
              }, 2000)
            }
          }).catch((error)=>{

          // alert(error)
        })
      },
      GetTime(selectedDate){
        this.timeslot=''
        var time=[];
        for(var x=0;x<this.teacherTime.times.length;x++){
          for(var y=0;y<this.teacherTime.times[x].length;y++){
            if(this.teacherTime.times[x][y].date==selectedDate){
              var Data={
                "time_from":this.teacherTime.times[x][y].time_from,
                "id":this.teacherTime.times[x][y].id
              }
              time.push(Data)
            }
          }
        }
        this.timeslot=time
      },
      getEnableList(val){
        let a=this.collectedDate
        // if(this.enableTimeCount==0){
        //   for(var i=0;i<8;i++){
        //     this.teacherTime.times[i].map(time => {
        //       this.collectedDate.push(time.date)
        //     });
        //     this.enableTimeCount=1
        //   }
        // }
        if(this.arrayEvents.includes(val)){
          return true
        }else{
          return false
        }
      }
    },
    computed: {
      ...mapState({
        classDetails: "classDetails",
        studentFullClassDetails:"studentFullClassDetails"
      })
    },
    components:{
      practicalbook,
      theorybook,
      CalenderBook,
      Complete
    }
  }
</script>
<style>
  .v-btn--small{
    /*width: 104px !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/student/StudentClasses.vue